import * as actionTypes from 'ActionTypes';

export const setSidebar = (status) => {
	return {
		type: actionTypes.SET_SIDEBAR,
		isOpen: status
	};
};